// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

function nextWeek() {
  let today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
}

export function Patient(name, phone, email, startdate = new Date()) {
  this.ID = undefined;
  this.Name = name;
  this.Phone = phone;
  this.Email = email;
  this.StartDate = startdate;
  this.AcceptNotification = false;
  this.Recipients = [];
  this.Reminders = [];
}

export function Recipient(name, phone, email) {
  this.Name = name || '';
  this.Phone = phone; 
  this.Email = email;
}

export function Reminder(messages, offset, messageType) {
  this.MessageType = messageType || "custom";
  this.Offset = offset || 0;
  this.Message = messages;
  this.Recipients = [];
}

export function Dose() {
  
}

export function Schedule(patientID, cardID, startdate = new Date(), enddate = nextWeek()) {
  this.ID = undefined;
  this.PatientID = patientID;
  this.CardID = cardID;
  this.StartDate = startdate;
  this.EndDate = enddate;
  this.Dose = [];
}
